export const BRAND_INFO = {
  CLIENT_NAME: "Claro Play",
  CLIENT_DESCRIPTION:
    "Películas y series online, deportes en vivo.",
};
